const CONNECTION = 'CONNECTION';
const CONNECTION_PENDING = 'CONNECTION_PENDING';
const CONNECTION_SUCCESS = 'CONNECTION_SUCCESS';
const CONNECTION_ERROR = 'CONNECTION_ERROR';

const DISCONNECT = 'DISCONNECT';
const DISCONNECT_PENDING = 'DISCONNECT_PENDING';
const DISCONNECT_SUCCESS = 'DISCONNECT_SUCCESS';
const DISCONNECT_ERROR = 'DISCONNECT_ERROR';

const ATTEMPTING_RECONNECT = 'ATTEMPTING_RECONNECT';
const ATTEMPTING_RECONNECT_PENDING = 'ATTEMPTING_RECONNECT_PENDING';
const ATTEMPTING_RECONNECT_SUCCESS = 'ATTEMPTING_RECONNECT_SUCCESS';
const ATTEMPTING_RECONNECT_FAILED = 'ATTEMPTING_RECONNECT_FAILED';

const HELLO = 'HELLO';
const HELLO_ERROR = 'HELLO_ERROR';
const HELLO_SUCCESS = 'HELLO_SUCCESS';

export default {
    CONNECTION,
    CONNECTION_ERROR,
    CONNECTION_PENDING,
    CONNECTION_SUCCESS,

    DISCONNECT,
    DISCONNECT_ERROR,
    DISCONNECT_PENDING,
    DISCONNECT_SUCCESS,

    ATTEMPTING_RECONNECT,
    ATTEMPTING_RECONNECT_FAILED,
    ATTEMPTING_RECONNECT_PENDING,
    ATTEMPTING_RECONNECT_SUCCESS,

    HELLO,
    HELLO_ERROR,
    HELLO_SUCCESS,
};



// WEBPACK FOOTER //
// ./src/redux/modules/connection/constants.ts